interface ContactAttemptsLoadErrorProps {
    onRetry: () => void;
}

// Shown in a history list when the contact attempts didn't load, so the list
// isn't read as "no one has been contacted".
const ContactAttemptsLoadError = ({ onRetry }: ContactAttemptsLoadErrorProps) => (
    <div className='mt-3 flex items-center justify-between gap-3 rounded border border-danger/30 bg-danger/5 px-3 py-2 text-sm'>
        <span className='text-danger'>
            Contact attempts didn't load, so they're missing from this list.
        </span>
        <button
            type='button'
            onClick={onRetry}
            className='shrink-0 font-bold text-black underline hover:no-underline'
        >
            Try again
        </button>
    </div>
);

export default ContactAttemptsLoadError;
